const MOBILE_HEADER_HEIGHT = 40
const INIT_TIMEOUT = 2000
const VIDEO_TIMEOUT = 2200

class VimeoLoader {
  constructor () {
    this.completed = false
    setTimeout(this.init, INIT_TIMEOUT)
  }
  init () {
    let head = document.getElementsByTagName('head')[0]
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://player.vimeo.com/api/player.js'

    script.onreadystatechange = vimeoLoader.callback
    script.onload = vimeoLoader.callback
    script.onerror = vimeoLoader.onError

    head.appendChild(script)

    vimeoLoader.timeout = setTimeout(vimeoLoader.onError, VIDEO_TIMEOUT)
  }
  callback () {
    vimeoLoader.complete(true)
  }
  onError () {
    vimeoLoader.complete(false)
  }
  complete (isAvailable) {
    clearTimeout(this.timeout)
    this.completed = true
    this.isAvailable = isAvailable
  }
}

const vimeoLoader = new VimeoLoader()

function VideoPlayer ($el, vimeoID, youkuIFrame, p) {
  if (!p) {
    p = {
      destroy () {
        clearTimeout(this.timeout)
        if (this.vimeo) {
          this.vimeo.destroy()
        }
        if (this.iframe) {
          this.iframe.remove()
          this.iframe = null
        }
      },
      reload () {
        if (this._reloaded) {
          return null
        }
        if (this.iframe) {
          this.iframe.src = this.iframe.src
          this._reloaded = true
        }
      },
      pause () {
        if (this.vimeo) {
          this.vimeo.pause()
        }
      },
      setPoppedMode (val) {
        if (val === this.isPoppedMode) return
        this.isPoppedMode = val
        if (val) {
          $el.parentNode.classList.add('popped')
        } else {
          $el.parentNode.classList.remove('popped')
        }
      },
      onScroll () {
        let r = $el.parentNode.getBoundingClientRect()
        this.setPoppedMode(r.y < MOBILE_HEADER_HEIGHT)
      }
    }
  }
  if (vimeoLoader.completed) {
    if (vimeoLoader.isAvailable) {
      p.vimeo = new window.Vimeo.Player($el, {
        id: vimeoID,
        width: window.innerWidth,
        title: false,
        byline: false,
        portrait: false,
        autoplay: false,
        autopause: true,
        playsinline: true,
        transparent: true,
        loop: true
      })
    } else {
      p.iframe = document.createElement('iframe')
      p.iframe.frameBorder = 0
      p.iframe.setAttribute('src', youkuIFrame)
      p.iframe.setAttribute('webkitallowfullscreen', true)
      p.iframe.setAttribute('mozallowfullscreen', true)
      p.iframe.setAttribute('allowfullscreen', true)
      $el.appendChild(p.iframe)
    }
  } else {
    p.timeout = setTimeout(VideoPlayer, 200, $el, vimeoID, youkuIFrame, p)
  }
  return p
}

export default VideoPlayer
